/** @jsx jsx */
import React, {useState, useEffect} from 'react';
import { css, jsx } from '@emotion/core';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { productColor } from 'components/styles';
import Icon, {IconType} from 'components/atoms/Icon';
import BodyText from "components/atoms/BodyText";
import { useHistory, useLocation } from 'react-router-dom';
import { MenuItem } from 'components/templates/menuData';

const style = {
  boxItem: css({
    padding: "10px 29px", 
    color: "#999999", 
    fontSize: "12px",
    "&:hover": {
      background: "#E7F1FD",
      color: productColor.primary,
      cursor: "pointer"
    }
  }),
  boxSubItem: css({
    cursor: "pointer",
    justifyContent: 'space-between',
    padding: '5px',
    '&:hover': {
      background: '#e7f1fd'
    }
  }),
  subMenuLevel1: css({
    padding: "10px", 
    cursor: "pointer"
  }),
  activeItem: css({
    background: "#E7F1FD",
    color: productColor.primary,
    cursor: "pointer"
  }),
  boxSubMenu: css({
    overflow: 'hidden',
    maxHeight: '1000px',
    transition: 'max-height 1.2s linear'
  })
};

const BoxMenu: React.FC<{
  subMenu: MenuItem,
  index: number,
  level: number
  openMenu?: boolean,
  setIndexOpen?: (index: number|null) => void,
}> = ({ subMenu, index, level, openMenu, setIndexOpen }) => {
  const history = useHistory();
  const location = useLocation();
  let group = location.pathname.split('/')[1];
  const currentUrl = group === subMenu.value ;
  const [indexSubOpen, setIndexSubOpen] = useState<number|null>()

  const handleOpenMenu = () => {
    if(openMenu) {
      setIndexOpen!(null);
    }else {
      setIndexOpen!(index);
    }

    if(!subMenu.subMenu) {
      history.push(subMenu.value);
    }
  };

  let listSubMenu = subMenu.subMenu?.map((subMenu: MenuItem, index: number) => {
    return (
      <BoxMenu
        subMenu={subMenu}
        index={index}
        level={level+1}
        openMenu={index === indexSubOpen}
        setIndexOpen={(i: number|null) => setIndexSubOpen(i)}
      />
    );
  });

  return(
    <div>
      <FlexBox customStyle={css([style.boxSubItem, (openMenu && subMenu.subMenu?.length === 0) || currentUrl ? { background: '#e7f1fd'} : {}])} onClick={handleOpenMenu}>
        <FlexBoxItem customStyle={css({ textIndent: `${level*15}px` })}> 
          <BodyText color="#666666">{subMenu.display}</BodyText>
        </FlexBoxItem>
        {subMenu.subMenu && subMenu.subMenu.length > 0 && (
          <FlexBoxItem customStyle={css([openMenu ? {transform: 'rotate(90deg)'} : {}, {transition: '0.5s'}])}>
            <Icon 
              type={"chevronMenu"}
              color={productColor.primary} 
              size="12px" 
              verticalAlign="middle" 
            />
          </FlexBoxItem>
        )}
      </FlexBox>
      <div css={css([style.boxSubMenu, openMenu ? {} : {maxHeight: '0', transition: 'max-height 0.8s linear'}])}>
        {listSubMenu}
      </div>
    </div>
  );
};

export default BoxMenu;
